<template>
  <v-flex>
    <v-select :id="typeInputId" v-model="selections"
              :items="items"
              ref="selections"
              hide-selected
              :label="$t('intervention_recipients.recipients_label')"
              multiple chips
              deletable-chips
              autocomplete
              hide-details
              :rules="rule"
              :required="ruleRequired">
    </v-select>
    <span v-if="invalidFreestyleEmail" class="caption error--text">{{$t('intervention_recipients.invalid_email')}}</span>
    <v-checkbox v-model="freestyle"
                :label="$t('intervention_recipients.freestyle_checkbox_label')"
                hide-details>
    </v-checkbox>
    <v-text-field :id="freestyleInputId" v-if="freestyle"
                  v-model="freeTextSelection"
                  :hint="$t('intervention_recipients.freestyle_hint')"
                  :placeholder="$t('intervention_recipients.freestyle_placeholder')"
                  clearable
                  v-on:keyup.enter="updateFreeText">
    </v-text-field>
  </v-flex>
</template>
<script>
  import { mapState, mapMutations } from 'vuex'
  import {
    SET_SELECTED_RECIPIENT_USER_TYPES,
    CONCAT_INTERVENTION_RECIPIENT_TYPES,
    SET_INTERVENTION_INVALID_EMAIL_STATUS,
    CONCAT_TEMPLATE_RECIPIENT_TYPES
  } from '../../store/mutation-types'

  export default {
    name: 'combo-box',
    data () {
      return {
        freeTextSelection: '',
        freestyle: false
      }
    },
    props: {
      id: {
        type: String
      },
      items: {
        type: Array
      },
      parent: {
        type: String
      },
      selectedTemplateRecipients: {
        type: Array
      },
      rule: {
        type: Array
      }
    },
    methods: {
      ...mapMutations({
        setRecipientUserTypes: SET_SELECTED_RECIPIENT_USER_TYPES,
        concatInterventionRecipientType: CONCAT_INTERVENTION_RECIPIENT_TYPES,
        concatTemplateRecipientType: CONCAT_TEMPLATE_RECIPIENT_TYPES,
        setInvalidEmailStatus: SET_INTERVENTION_INVALID_EMAIL_STATUS
      }),
      concatFreeTest (obj) {
        if (this.isTemplate) {
          this.concatTemplateRecipientType(obj)
        } else {
          this.concatInterventionRecipientType(obj)
        }
      },
      updateFreeText () {
        if (this.emailReg.test(this.freeTextSelection)) {
          let obj = {
            text: this.freeTextSelection,
            value: this.freeTextSelection
          }
          this.concatFreeTest(obj)
          this.selections = this.selections.concat(this.freeTextSelection)
        }
        this.freeTextSelection = ''
      },
      getInvalidEmails (selected) {
        let invalidEmails = []
        selected.forEach(el => {
          // ignore original types
          if (!this.originalValues.includes(el)) {
            // focus on invalid emails only
            if (!this.emailReg.test(el)) {
              invalidEmails.push(el)
            }
          }
        })
        return invalidEmails
      },
      invalidEmailExist (selected) {
        // if invalidEmails exists in selected
        return this.getInvalidEmails(selected).some(v => selected.indexOf(v) !== -1)
      }
    },
    computed: {
      ...mapState({
        selectedUserRecipients: state => state.intervention.selectedUserRecipients,
        originalRecipientTypes: state => state.intervention.originalRecipientTypes,
        invalidFreestyleEmail: state => state.intervention.invalidFreestyleEmail,
        emailReg: state => state.intervention.emailReg
      }),
      ruleRequired () {
        return typeof (this.rule) !== 'undefined'
      },
      typeInputId () {
        return this.id + '-user-type-input'
      },
      freestyleInputId () {
        return this.id + '-freestyle-type-input'
      },
      originalValues () {
        return this.originalRecipientTypes.map(el => el.value)
      },
      isTemplate () {
        return this.parent === 'template'
      },
      selectedValues () {
        return this.isTemplate ? this.selectedTemplateRecipients : this.selectedUserRecipients
      },
      checkLength () {
        return this.selectedValues.length > 0
      },
      selections: {
        get () {
          return this.checkLength ? this.selectedValues : []
        },
        set (val) {
          if (!this.invalidEmailExist(val)) {
            this.setInvalidEmailStatus(false)
          }

          if (this.isTemplate) {
            this.$emit('update-this-prop', {prop: 'emailRecipients', val: val})
          } else {
            this.setRecipientUserTypes(val)
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/intervention/ComboBox.vue